module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/superadmin/superadmin.component.scss
// module id = ./src/app/modules/superadmin/superadmin.component.scss
// module chunks = main